import { useContext, useState } from "react";
import { AppContext } from "../App";
import { MdArrowForward, MdKeyboardArrowDown, MdPhoneInTalk } from "react-icons/md";
import logo from "../assets/logo.png";
import { MdMenu, MdClose } from "react-icons/md";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  function goTo(item, subItem = null) {
    appContext.navTo({
      item,
      subItem,
    });
  }

    function openSideBar() {
    appContext.setIsSideBarOpen(true);
  }

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function isActive(item) {
    if (item === "home") {
      return !appContext.navItem || appContext.navItem === "home";
    }
    return appContext.navItem === item;
  }

  function selectAbout(subItem) {
    setAboutOpen(false);
    if (document.activeElement) {
      document.activeElement.blur();
    }
    goTo("about", subItem);
  }

  function selectServices(subItem) {
    setServicesOpen(false);
    if (document.activeElement) {
      document.activeElement.blur();
    }
    goTo("services", subItem);
  }

  return (
    <header className="TopBar">
      <div className="container topbar-inner">
        
        {/* LEFT BRAND SECTION */}
        <div className="brand-lockup" onClick={() => goTo("home")}>
          <img src={logo} alt="Blessing Management Consultancy" className="brand-logo-img" />
          <div className="brand-title-group">
            <strong className="font-title-bold text-primary">Blessing</strong>
            <span className="font-regular text-muted">MANAGEMENT CONSULTANCY</span>
          </div>
        </div>

        {/* CENTER LINKS SECTION */}
        <nav className="DesktopMenu mDesktopOnly">
          <button
            className="topbar-link font-semi-bold"
            data-active={isActive("home")}
            onClick={() => goTo("home")}
          >
            Home
          </button>

          {/* About Dropdown */}
          <div
            className="topbar-dropdown"
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <button
              className="topbar-link font-semi-bold"
              data-active={isActive("about")}
              onClick={() => setAboutOpen((current) => !current)}
            >
              About
              <MdKeyboardArrowDown className="dropdown-caret" />
            </button>

            <div className="topbar-dropdown-menu mShadow2" data-open={aboutOpen}>
              <button className="font-regular" onClick={() => selectAbout("overview")}>Overview</button>
              <button className="font-regular" onClick={() => selectAbout("team")}>Our Team</button>
            </div>
          </div>

          {/* Services Dropdown */}
          <div
            className="topbar-dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button
              className="topbar-link font-semi-bold"
              data-active={isActive("services")}
              onClick={() => setServicesOpen((current) => !current)}
            >
              Services
              <MdKeyboardArrowDown className="dropdown-caret" />
            </button>

            <div className="topbar-dropdown-menu mShadow2" data-open={servicesOpen}>
              <button className="font-regular" onClick={() => selectServices("audit")}>Audit & Assurance</button>
              <button className="font-regular" onClick={() => selectServices("tax")}>Taxation & Compliance</button>
              <button className="font-regular" onClick={() => selectServices("accounting")}>Accounting Advisory</button>
              <button className="font-regular" onClick={() => selectServices("advisory")}>Management Advisory</button>
            </div>
          </div>

          <button
            className="topbar-link font-semi-bold"
            data-active={isActive("contact")}
            onClick={() => goTo("contact")}
          >
            Contact
          </button>
        </nav>

        {/* RIGHT ACTION BUTTON SECTION */}
        <div className="topbar-actions mDesktopOnly">
          <button className="topbar-quote" onClick={() => goTo("contact")}>
            <MdPhoneInTalk className="cta-icon-phone" />
            <span className="font-semi-bold">Free Consultation</span>
            <MdArrowForward className="quote-arrow" />
          </button>
        </div>

        {/* 2. MOBILE TRIGGER HAMBURGER BUTTON (Renders dynamically via your CSS layout) */}
        <button 
          className="MainMenuBtn" 
          onClick={appContext.isSideBarOpen ? closeSideBar : openSideBar}
          aria-label="Toggle Menu"
        >
          {appContext.isSideBarOpen ? (
                  <MdClose />
                ) : (
                  <MdMenu />
                )}
        </button>

      </div>
    </header>
  );
}